import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { changeCustomersList } from "../../store/customer";
import {
  getFilterByType,
  getModalStatus,
  getSortByStatus,
  getSortOrderStatus
} from "../../store/common";
import { getTranslate } from "react-localize-redux";
import { InputGroup, InputGroupAddon, Input, Button } from "reactstrap";

const CustomersFilter = ({
  changeCustomersList,
  getNameFilter,
  getLocationFilter,
  getCodeFilter,
  translate
}) => {
  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div className="filterSetup customersFilter">
          <h5 className="filterSetup__heading">
            {translate(
              "molecules.containers.customersFilter.search_in_customer"
            )}
          </h5>
          <div className="row">
            <div className="col">
              <div className="filterSetup__inputGroup ">
                <label htmlFor="code">
                  {translate(
                    "molecules.containers.customersFilter.customer_name"
                  )}
                </label>
                <InputGroup>
                  <Input
                    type="text"
                    value={getNameFilter}
                    onChange={e => {
                      changeCustomersList(e.target.value, "name");
                      e.stopPropagation();
                    }}
                    className="form-control"
                    placeholder={translate(
                      "molecules.containers.customersFilter.customer_name"
                    )}
                    aria-label={translate(
                      "molecules.containers.customersFilter.customer_name"
                    )}
                    aria-describedby="basic-addon2"
                  />
                  {/* {getNameFilter && <InputGroupAddon addonType="append"><Button onClick={()=>changeCustomersList('', 'name')}>X</Button></InputGroupAddon>} */}
                </InputGroup>
              </div>
            </div>
            <div className="col">
              <div className="filterSetup__inputGroup">
                <label htmlFor="name">
                  {translate(
                    "molecules.containers.customersFilter.personal_code"
                  )}
                </label>
                <InputGroup>
                  <Input
                    type="text"
                    value={getCodeFilter}
                    onChange={e => {
                      changeCustomersList(e.target.value, "code");
                      e.stopPropagation();
                    }}
                    className="form-control"
                    placeholder={translate(
                      "molecules.containers.customersFilter.personal_code"
                    )}
                    aria-label={translate(
                      "molecules.containers.customersFilter.personal_code"
                    )}
                    aria-describedby="basic-addon2"
                  />
                  {/* {getCodeFilter && <InputGroupAddon addonType="append"><Button onClick={()=>changeCustomersList('', 'code')}>X</Button></InputGroupAddon>} */}
                </InputGroup>
              </div>
            </div>
            <div className="col">
              <div className="filterSetup__inputGroup">
                <label htmlFor="name">
                  {translate("molecules.containers.customersFilter.location")}
                </label>
                <InputGroup>
                  <Input
                    type="text"
                    value={getLocationFilter}
                    onChange={e => {
                      changeCustomersList(e.target.value, "location");
                      e.stopPropagation();
                    }}
                    className="form-control"
                    placeholder={translate(
                      "molecules.containers.customersFilter.location"
                    )}
                    aria-label={translate(
                      "molecules.containers.customersFilter.location"
                    )}
                    aria-describedby="basic-addon2"
                  />
                  {/* {getLocationFilter && <InputGroupAddon addonType="append"><Button onClick={()=>changeCustomersList('', 'location')}>X</Button></InputGroupAddon>} */}
                </InputGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
CustomersFilter.propTypes = {
  changeCustomersList: PropTypes.func,
  getNameFilter: PropTypes.string,
  getLocationFilter: PropTypes.string,
  getCodeFilter: PropTypes.string,
  translate: PropTypes.func
};

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  getNameFilter: getFilterByType(state.customer.filter, "name"),
  getLocationFilter: getFilterByType(state.customer.filter, "location"),
  getCodeFilter: getFilterByType(state.customer.filter, "code"),
  getFilterSortDropdownStatus: getModalStatus(
    state.common.modals.filter_customers_sort
  ),
  getSortBy: getSortByStatus(state.customer.sortBy),
  getSortOrder: getSortOrderStatus(state.customer.sortOrder)
});

const mapDispatchToProps = dispatch => ({
  changeCustomersList: (val, type) => {
    dispatch(changeCustomersList(val, type));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomersFilter);



// WEBPACK FOOTER //
// ./src/molecules/containers/CustomersFilter.js